import styled from 'styled-components';
import { Card } from 'antd';

export const DashboardIntroCard = styled(Card)`
  margin: 24px;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.09);
  border-radius: 4px;
  border: 1px solid #fff;

  .ant-card-body {
    padding: 0;
  }
`;

export const DashboardWrapper = styled.div`
  .intro-card {
    height: 40vh;
    background: url('/images/lectures.svg') no-repeat center center;
    background-size: contain;
    padding: 24px;
    background-color: #e4f0ff;
  }

  .dashboard-inner {
    margin: 24px;
  }

  .dashboard-inner-card {
    box-shadow: 3px 0 5px rgba(0, 0, 0, 0.09);
    border-radius: 4px;
    border: 1px solid #fff;
    cursor: pointer;

    .ant-card-body {
      display: flex;
      align-items: center;
    }

    #hsms-icon {
      margin-top: -1px;
      margin-right: 10px;
    }
  }

  .dashboard-link-icon {
    font-size: 20px !important;
    padding-top: 2px;
  }

  .dashboard-link-arrow-icon {
    font-size: 20px !important;
    padding-top: 2px;
  }

  .inner-link-spacer {
    flex: 1;
  }
`;
